import script from "./FlatButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./FlatButton.vue?vue&type=script&lang=ts&setup=true"

import "./FlatButton.vue?vue&type=style&index=0&id=3e53cc23&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\TelAvivMuseum.Web\\museum-telaviv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e53cc23"]])

export default __exports__